import React from 'react';
import './login_providers.scss';
import ListComponent from '../metype_home/list_component';
import ShowSignupButton from './form_login_modal/signup_button';

const LoginProviders = ({userLogin}) => {
  return(
    <div className="login-providers-container">
     <div className="login-providers-text">Or sign in with</div>
     <ListComponent redirect={true} accountSignupModal={true} className="list-component" userLogin={userLogin}/>
     <ShowSignupButton />
    </div>
  )
}

export default LoginProviders;


// WEBPACK FOOTER //
// ./app/javascript/pages/page/login_providers.js